export type SectionId = 'panoramica' | 'contenuti' | 'aspetto' | 'accesso' | 'qualita';

export const SECTIONS: { id: SectionId; label: string }[] = [
    { id: 'panoramica', label: 'Panoramica' },
    { id: 'contenuti', label: 'Contenuti' },
    { id: 'aspetto', label: 'Icona e logo' },
    { id: 'accesso', label: 'Accesso' },
    { id: 'qualita', label: 'Qualità' },
];

/** Vecchi nomi delle schede (link salvati, ?tab=) verso le sezioni nuove. */
const LEGACY: Record<string, SectionId> = {
    info: 'panoramica', immagini: 'aspetto', guide: 'contenuti', utenti: 'accesso', diagnostica: 'qualita', assistente: 'qualita',
};

export const sectionFrom = (value: string | null): SectionId =>
    (SECTIONS.find(s => s.id === value)?.id) ?? (value ? LEGACY[value] : undefined) ?? 'panoramica';
